import styled from 'styled-components';

export const SelectionOptionsTitle = styled.legend`
  color: ${Styles.color.black};
  font-family: ${Styles.fontFamily.base};
  font-weight: ${Styles.fontWeight.normal};
  letter-spacing: 'normal';
  font-size: 1.25rem;
  padding: 0;
`;
